<form [formGroup]="parentFormGroup" id="{{baseId}}-modal-form" #form="ngForm">
  <div class="emds">
    <div class="modal-default modal-flex">
      <div class="modal-header">
        <span id="{{baseId}}-header-title" translate>Modify Find Table - {{findControlBehaviorName}}</span>
      </div>

      <div class="modal-body">

        <ap-alert></ap-alert>

        <div class="tabs tabs-default tabs-flex">
          <mat-tab-group [selectedIndex]="selectedTabIndex | async">
            <mat-tab id="{{baseId}}-information-tab-element">
                    <ng-template mat-tab-label>
                      Information
                      <span *ngIf="(form.submitted
                                  && parentFormGroup
                                  && parentFormGroup.controls.informationTab
                                  && parentFormGroup.controls.informationTab.invalid)">
                        <span class="badge"
                              [ngClass]="badgeType"
                              id="{{baseId}}-information-tab-error-icon">{{ informationTabErrorCount }}</span>
                      </span>
                    </ng-template>
                    <ap-findcontrol-modify-information-tab-component
                      [baseId]="baseId"
                      [isLoading]="isLoading"
                      [findControlBehavior]="findControlBehavior"
                      [informationTabFormGroup]="parentFormGroup.controls.informationTab"
                      [form]="form"
                      (errorCountChange)="onErrorCountChangeInformationTab($event)">
                    </ap-findcontrol-modify-information-tab-component>
            </mat-tab>

            <mat-tab id="{{baseId}}-security-tab-element"
                 *ngIf="!isLoading && doesFindControlHaveSecurity">
                    <ng-template mat-tab-label>
                      Security
                      <span *ngIf="(form.submitted
                                    && parentFormGroup
                                    && parentFormGroup.controls.securityTab
                                    && parentFormGroup.controls.securityTab.invalid)">
                        <span class="badge"
                              [ngClass]="badgeType"
                              id="{{baseId}}-security-tab-error-icon">{{ securityTabErrorCount }}</span>
                      </span>
                    </ng-template>
                    <ap-findcontrol-modify-security-tab-component
                      [baseId]="baseId"
                      [securityGroupUid]="securityGroupUid"
                      [findControlBehaviorSecurity]="findControlBehaviorSecurity"
                      [securityTabFormGroup]="parentFormGroup.controls.securityTab"
                      [form]="form"
                      (errorCountChange)="onErrorCountChangeSecurityTab($event)">
                    </ap-findcontrol-modify-security-tab-component>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>

      <div class="modal-footer">
        <button id="{{baseId}}-close-btn"
                class="btn btn-primary"
                [disabled]="!parentFormGroup?.dirty || loadingError"
                (click)="onClose()" translate>
          <ap-spinner *ngIf="saving; else notSaving" size="1"></ap-spinner>
          <ng-template #notSaving>
            <span>Save</span>
          </ng-template>
        </button>
        <button id="{{baseId}}-cancel-btn"
                class="btn btn-secondary btn-flush-right"
                (click)="onCancel()" translate>Cancel</button>
      </div>
    </div>
  </div>
</form>
